import { api as client } from './client';

export type VetCatalogService = {
  name: string;
  priceEur?: number;
  pricingType: 'fijo' | 'variable';
};

export type VetDirectoryItem = {
  _id: string;
  name: string;
  avatarUrl?: string;
  city?: string;
  specialties: string[];
  services: string[];
  serviceCatalog: VetCatalogService[];
  schedule?: string;
  emergency24h: boolean;
};

export type VetAppointmentStatus = 'requested' | 'confirmed' | 'rescheduled' | 'completed' | 'cancelled';

export type VetAppointment = {
  _id: string;
  vetId: any;
  userId: any;
  animalId?: any;
  animalCode?: string;
  reason: string;
  service?: VetCatalogService;
  requestedAt: string;
  scheduledAt?: string;
  status: VetAppointmentStatus;
  vetNotes?: string;
  cancelReason?: string;
  patitasCost?: number;
  patitasPaid?: boolean;
  payoutStatus?: 'none' | 'pending_payout' | 'paid';
  createdAt?: string;
};

export async function listVets(params?: { city?: string; q?: string }) {
  const { data } = await client.get('/api/vets', { params });
  return data as { items: VetDirectoryItem[] };
}

export async function createVetAppointment(payload: { vetId: string; reason: string; requestedAt: string; animalCode?: string; serviceName?: string; patitasCost?: number }) {
  // Cada pantalla traduce sus errores (AUD-3): sin esto salía también el código crudo.
  const { data } = await client.post('/api/vet-appointments', payload, { skipErrorToast: true } as any);
  return data as VetAppointment;
}

export async function listMyVetAppointments(status?: VetAppointmentStatus) {
  const { data } = await client.get('/api/vet-appointments/mine', { params: status ? { status } : undefined });
  return data as { items: VetAppointment[] };
}

export async function updateVetAppointmentStatus(
  id: string,
  payload: { status: VetAppointmentStatus; scheduledAt?: string; vetNotes?: string; cancelReason?: string; addToHistory?: boolean },
) {
  // El panel ya toastea su propio error (y el aviso de que las Patitas no se
  // han cobrado); sin esto salían dos.
  const { data } = await client.patch(`/api/vet-appointments/${id}/status`, payload, { skipErrorToast: true } as any);
  return data as VetAppointment;
}

// Feed iCal de la agenda del vet (para suscribir Google/Apple/Outlook).
export async function getVetCalendarFeed() {
  const { data } = await client.get('/api/vets/me/calendar-feed');
  return data as { url: string };
}

export async function rotateVetCalendarFeed() {
  const { data } = await client.post('/api/vets/me/calendar-feed/rotate');
  return data as { url: string };
}

/** Huecos libres de un veterinario (hora de España): días con las horas que aún se pueden pedir. */
export type VetAvailability = {
  agendaPropia: boolean;
  agenda: { dias: number[]; horas: string[] };
  dias: Array<{ fecha: string; horas: string[] }>;
};

export async function getVetAvailability(vetId: string, desde: string, dias: number) {
  const { data } = await client.get(`/api/vets/${vetId}/availability`, { params: { desde, dias } });
  return data as VetAvailability;
}
